<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
    <form class="input-wrap" @submit="submit" @click="$emit('inputClick')">
      <input
        v-model="model"
        type="text"
        :placeholder="placeholder"
        class="input"
        ref="inputEl"
      >
      <i v-if="!value" class="icon search"></i>
      <i v-else class="icon clear" @click="clear"></i>
    </form>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: [String, Number],
    placeholder: {
      type: String,
      default: '',
    },
    focus: Boolean,
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
  },
  mounted() {
    // eslint-disable-next-line no-unused-expressions
    this.focus && this.$refs.inputEl && this.$refs.inputEl.focus();
  },
  methods: {
    clear() {
      this.model = '';
    },
    submit(e) {
      e.preventDefault();
      this.$emit('submit');
    },
  },
};
</script>

<style lang="less" scoped>
.input-wrap {
  height: 44px;
  border-radius: 22px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  background-color: #fff;
  .input {
    flex: 1;
    height: 24px;
    color: @black;
    font-size: 18px;
    &::placeholder {
      color: @gray;
      font-size: 16px;
    }
  }

  .icon {
    .iconMixin();
    &.clear {
      background-image: url('@/assets/images/icon/clear.png');
    }
    &.search {
      background-image: url('@/assets/images/icon/search.png');
    }
  }

}

</style>
